import React, { ReactNode, useEffect, useState } from "react";

interface ToolbarProps {
    id: string;
    children?: ReactNode;
}

export const Toolbar = ({ id, children }: ToolbarProps) => {
    const [showChildren, setShowChildren] = useState(false);

    useEffect(() => {
        // Children must be rendered after the first mount
        // otherwise Quill will overwrite them
        setShowChildren(true);
    }, []);

    return (
        <div id={id} className="flex flex-wrap items-center !border-none bg-secondary-lighter p-1">
            <span className="ql-formats rounded border-2 border-secondary-light">
                <select className="ql-size" defaultValue="16px">
                    <option value="10px">Small</option>
                    <option value="16px">Normal</option>
                    <option value="18px">Large</option>
                    <option value="32px">Huge</option>
                </select>
            </span>

            <span className="ql-formats rounded border-2 border-secondary-light">
                <button className="ql-bold" type="button" />
                <button className="ql-italic" type="button" />
                <button className="ql-underline" type="button" />
            </span>

            <span className="ql-formats rounded border-2 border-secondary-light">
                <select className="ql-color ql-picker ql-color-picker">
                    <option value="#e60000" />
                    <option value="#ff9900" />
                    <option value="#ffff00" />
                    <option value="#008a00" />
                    <option value="#0066cc" />
                    <option value="#9933ff" />
                    <option value="#ffffff" />
                    <option value="#facccc" />
                    <option value="#ffebcc" />
                    <option value="#ffffcc" />
                    <option value="#cce8cc" />
                    <option value="#cce0f5" />
                    <option value="#ebd6ff" />
                    <option value="#bbbbbb" />
                    <option value="#f06666" />
                    <option value="#ffc266" />
                    <option value="#ffff66" />
                    <option value="#66b966" />
                    <option value="#66a3e0" />
                    <option value="#c285ff" />
                    <option value="#888888" />
                    <option value="#a10000" />
                    <option value="#b26b00" />
                    <option value="#b2b200" />
                    <option value="#006100" />
                    <option value="#0047b2" />
                    <option value="#6b24b2" />
                    <option value="#444444" />
                    <option value="#5c0000" />
                    <option value="#663d00" />
                    <option value="#666600" />
                    <option value="#003700" />
                    <option value="#002966" />
                    <option value="#3d1466" />
                    <option value="#000000" />
                </select>
                <select className="ql-background ql-picker ql-color-picker">
                    <option value="#e60000" />
                    <option value="#ff9900" />
                    <option value="#ffff00" />
                    <option value="#008a00" />
                    <option value="#0066cc" />
                    <option value="#9933ff" />
                    <option value="#ffffff" />
                    <option value="#facccc" />
                    <option value="#ffebcc" />
                    <option value="#ffffcc" />
                    <option value="#cce8cc" />
                    <option value="#cce0f5" />
                    <option value="#ebd6ff" />
                    <option value="#bbbbbb" />
                    <option value="#f06666" />
                    <option value="#ffc266" />
                    <option value="#ffff66" />
                    <option value="#66b966" />
                    <option value="#66a3e0" />
                    <option value="#c285ff" />
                    <option value="#888888" />
                    <option value="#a10000" />
                    <option value="#b26b00" />
                    <option value="#b2b200" />
                    <option value="#006100" />
                    <option value="#0047b2" />
                    <option value="#6b24b2" />
                    <option value="#444444" />
                    <option value="#5c0000" />
                    <option value="#663d00" />
                    <option value="#666600" />
                    <option value="#003700" />
                    <option value="#002966" />
                    <option value="#3d1466" />
                    <option value="#000000" />
                </select>
            </span>

            <span className="ql-formats rounded border-2 border-secondary-light">
                <button className="ql-header" value="1" type="button" />
                <button className="ql-header" value="2" type="button" />
                <button className="ql-blockquote" type="button" />
            </span>

            <span className="ql-formats rounded border-2 border-secondary-light">
                <button className="ql-list" value="ordered" type="button" />
                <button className="ql-list" value="bullet" type="button" />
                <button className="ql-indent" value="-1" type="button" />
                <button className="ql-indent" value="+1" type="button" />
            </span>

            <span className="ql-formats rounded border-2 border-secondary-light">
                <select className="ql-align" />
            </span>

            <span className="ql-formats rounded border-2 border-secondary-light">
                <button className="ql-link" type="button" />
            </span>

            <span className="ql-formats rounded border-2 border-secondary-light">
                <button className="ql-clean" type="button" />
            </span>

            {showChildren ? <span className="py-2">{children}</span> : null}
        </div>
    );
};
